var _a;
import { outerWrapper, wrapper, wrapperScrollStart, wrapperScrollEnd, container, tabs, tab, target, targetError, targetActive, targetActiveError, emblem, emblemActive, emblemError, errorIcon, } from '../styles/legacy';
import { outerWrapper as outerWrapperCitrus2022, wrapper as wrapperCitrus2022, container as containerCitrus2022, tabs as tabsCitrus2022, tab as tabCitrus2022, target as targetCitrus2022, targetError as targetErrorCitrus2022, targetActive as targetActiveCitrus2022, targetActiveError as targetActiveErrorCitrus2022, emblem as emblemCitrus2022, emblemActive as emblemActiveCitrus2022, emblemError as emblemErrorCitrus2022, errorIcon as errorIconCitrus2022, } from '../styles/citron';
import { injectGlobal } from 'emotion';
import { citrusStyled } from '@citrus/runtime';
export var tabsScrollStartIdentifier = 'citrus-tabs-wrapper-scroll-start-a78fs0d';
export var tabsScrollEndIdentifier = 'citrus-tabs-wrapper-scroll-end-a78fs0d';
/** ***************************************************************************************
 *  GLOBAL rules
 *
 *  The identifiers are classes that we put on each button to identify it as this component
 *  but it does not have any associated rules by itself. It is used to facilitate
 *  combinators.
 *
 *  ##### If the globalRules ever change, this value MUST change to avoid collisions #### */
// To implement proper side by side spacing...
var globalRules = (_a = {},
    _a[".".concat(tabsScrollStartIdentifier)] = wrapperScrollStart,
    _a[".".concat(tabsScrollEndIdentifier)] = wrapperScrollEnd,
    _a);
injectGlobal(globalRules);
/** **************************************************************************************/
export var OuterWrapper = citrusStyled.div('outerWrapper', {
    legacy: outerWrapper,
    citrus2022: outerWrapperCitrus2022,
});
export var Wrapper = citrusStyled.div('wrapper', { legacy: wrapper, citrus2022: wrapperCitrus2022 });
export var Container = citrusStyled.div('container', { legacy: container, citrus2022: containerCitrus2022 });
export var Tabs = citrusStyled.ul('tabs', { legacy: tabs, citrus2022: tabsCitrus2022 });
export var Tab = citrusStyled.li('tab', { legacy: tab, citrus2022: tabCitrus2022 });
export var Target = citrusStyled.a('target', { legacy: target, citrus2022: targetCitrus2022 });
export var TargetError = citrusStyled.a('targetError', { legacy: targetError, citrus2022: targetErrorCitrus2022 });
export var TargetActive = citrusStyled.a('targetActive', {
    legacy: targetActive,
    citrus2022: targetActiveCitrus2022,
});
export var TargetActiveError = citrusStyled.a('targetActiveError', {
    legacy: targetActiveError,
    citrus2022: targetActiveErrorCitrus2022,
});
export var Emblem = citrusStyled.span('emblem', { legacy: emblem, citrus2022: emblemCitrus2022 });
export var EmblemActive = citrusStyled.span('emblemActive', {
    legacy: emblemActive,
    citrus2022: emblemActiveCitrus2022,
});
export var EmblemError = citrusStyled.span('emblemError', { legacy: emblemError, citrus2022: emblemErrorCitrus2022 });
export var ErrorIcon = citrusStyled.span('errorIcon', { legacy: errorIcon, citrus2022: errorIconCitrus2022 });
export var Styled = {
    OuterWrapper: OuterWrapper,
    Wrapper: Wrapper,
    Container: Container,
    Tabs: Tabs,
    Tab: Tab,
    Target: Target,
    TargetError: TargetError,
    TargetActive: TargetActive,
    TargetActiveError: TargetActiveError,
    Emblem: Emblem,
    EmblemActive: EmblemActive,
    EmblemError: EmblemError,
    ErrorIcon: ErrorIcon,
};
